import { useState } from "react"
import { useHistory, useLocation } from "react-router-dom"
import {
  TableErrorRowType,
  CountRecordType,
} from "../../../../../../../_webui/layout/components/Table/Error/models"
import { SchedulesBatchImportDataType } from "../../../../models/batchImport/data"
import { useTable } from "../../../../../../../utils/hook/useTable"

export const useVariablesApi = () => {
  const { push } = useHistory()
  const { pathname } = useLocation()
  const [errorList, setErrorList] = useState<TableErrorRowType[]>([])
  const [dataTemps, setDataTemps] = useState<SchedulesBatchImportDataType[]>([])
  const [countRecord, setCountRecord] = useState<CountRecordType>()
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingLayout, setIsLoadingLayout] = useState(true)
  const [isDisabledSubmit, setIsDisabledSubmit] = useState(true)
  const [isResetTable, setIsResetTable] = useState(false)
  const [fileNameList, setFileNameList] = useState<string[]>([])
  const { onChange, perItem } = useTable(dataTemps?.length)

  return {
    countRecord,
    dataTemps,
    errorList,
    fileNameList,
    isDisabledSubmit,
    isLoading,
    isLoadingLayout,
    isResetTable,
    onChange,
    pathname,
    perItem,
    push,
    setCountRecord,
    setDataTemps,
    setErrorList,
    setFileNameList,
    setIsDisabledSubmit,
    setIsLoading,
    setIsLoadingLayout,
    setIsResetTable,
  }
}
